import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { ModelConversionService } from '@shared/convert/model-conversion.service';
import { ProjectOptionDefVO } from '../../../model/vo/project.vo';
import { UserOptionDefsVO } from '@user/model/vo/user-option-defs.vo';
import { NumberUtils } from '@shared/util/number-utils';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ProjectOptionDefService {
  private readonly projectOptionDefUrl: string = 'project-option-def';
  private readonly loadOptionDefsByUserIdUrl: string = this.projectOptionDefUrl + '/search';

  constructor(private modelConversionService: ModelConversionService, private wagoApiClient: WagoApiClient) {}

  public saveProjectOptionDefs(userId: number, optionDefVO: ProjectOptionDefVO[]): void {
    const dto = {
      optionDefVO,
      userId,
    };
    this.wagoApiClient.post(this.projectOptionDefUrl, dto, { responseType: 'text' }).subscribe(() => {});
  }

  public loadOptionDefsByUserId(userId: number): Observable<UserOptionDefsVO> {
    let requestUrl: string = this.loadOptionDefsByUserIdUrl;
    if (NumberUtils.isNumber(userId)) {
      requestUrl = requestUrl + `?userId=${userId}`;
    }
    return this.wagoApiClient.get(requestUrl).pipe(map((response) => this.modelConversionService.convertUserOptionDefsVO(response)));
  }
}
